var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19814_8349",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19814_8349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 14.167C10.2359 14.167 10.434 14.087 10.594 13.927C10.7534 13.7675 10.8332 13.5698 10.8332 13.3337V9.97949C10.8332 9.74338 10.7534 9.54894 10.594 9.39616C10.434 9.24338 10.2359 9.16699 9.99984 9.16699C9.76373 9.16699 9.56595 9.24671 9.4065 9.40616C9.2465 9.56616 9.1665 9.76421 9.1665 10.0003V13.3545C9.1665 13.5906 9.2465 13.785 9.4065 13.9378C9.56595 14.0906 9.76373 14.167 9.99984 14.167ZM9.99984 7.50033C10.2359 7.50033 10.434 7.42033 10.594 7.26033C10.7534 7.10088 10.8332 6.9031 10.8332 6.66699C10.8332 6.43088 10.7534 6.23283 10.594 6.07283C10.434 5.91338 10.2359 5.83366 9.99984 5.83366C9.76373 5.83366 9.56595 5.91338 9.4065 6.07283C9.2465 6.23283 9.1665 6.43088 9.1665 6.66699C9.1665 6.9031 9.2465 7.10088 9.4065 7.26033C9.56595 7.42033 9.76373 7.50033 9.99984 7.50033ZM9.99984 18.3337C8.84706 18.3337 7.76373 18.1148 6.74984 17.677C5.73595 17.2398 4.854 16.6462 4.104 15.8962C3.354 15.1462 2.76039 14.2642 2.32317 13.2503C1.88539 12.2364 1.6665 11.1531 1.6665 10.0003C1.6665 8.84755 1.88539 7.76421 2.32317 6.75033C2.76039 5.73644 3.354 4.85449 4.104 4.10449C4.854 3.35449 5.73595 2.7606 6.74984 2.32283C7.76373 1.8856 8.84706 1.66699 9.99984 1.66699C11.1526 1.66699 12.2359 1.8856 13.2498 2.32283C14.2637 2.7606 15.1457 3.35449 15.8957 4.10449C16.6457 4.85449 17.2393 5.73644 17.6765 6.75033C18.1143 7.76421 18.3332 8.84755 18.3332 10.0003C18.3332 11.1531 18.1143 12.2364 17.6765 13.2503C17.2393 14.2642 16.6457 15.1462 15.8957 15.8962C15.1457 16.6462 14.2637 17.2398 13.2498 17.677C12.2359 18.1148 11.1526 18.3337 9.99984 18.3337ZM9.99984 16.667C11.8471 16.667 13.4201 16.0178 14.719 14.7195C16.0173 13.4206 16.6665 11.8475 16.6665 10.0003C16.6665 8.1531 16.0173 6.58005 14.719 5.28116C13.4201 3.98283 11.8471 3.33366 9.99984 3.33366C8.15262 3.33366 6.57984 3.98283 5.2815 5.28116C3.98261 6.58005 3.33317 8.1531 3.33317 10.0003C3.33317 11.8475 3.98261 13.4206 5.2815 14.7195C6.57984 16.0178 8.15262 16.667 9.99984 16.667Z",
    fill: "#4D4D4D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGrayIcon);
export default __webpack_public_path__ + "static/media/infoGrayIcon.61bd746e5230409e8977a9b40377ba11.svg";
export { ForwardRef as ReactComponent };